import { Settings as LayoutSettings } from '@ant-design/pro-layout'

const Settings: LayoutSettings & {
    pwa?: boolean;
    logo?: string;
    beidouPid: number;
} = {
  navTheme: 'light',
  // 拂晓蓝
  primaryColor: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: 'OpenCMS',
  pwa: false,
  logo:
        'https://wos2.58cdn.com.cn/DeFazYxWvDti/frsupload/15f65c8152d7d5c81e3b236543137bfa_cmslogo.svg',
  iconfontUrl: '',
  beidouPid: 133
}

export default Settings
